import { reducer as forms } from "redux-form";
import { firebaseReducer } from "react-redux-firebase";
import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import modals from "./modals";
import user from "./user";
import common from "./common";
import firebasePersistTransform from "./firebasePersistTransform";

const config = {
  key: "primary",
  storage,
  blacklist: ["modals", "common"],
  transforms: [firebasePersistTransform],
};

const rootStore = persistCombineReducers(config, {
  firebase: firebaseReducer,
  common,
  user,
  modals,
  forms,
});

export default rootStore;
